import { render } from "./GeneralInfo.vue?vue&type=template&id=16355aac&scoped=true&ts=true"
import script from "./GeneralInfo.vue?vue&type=script&lang=ts"
export * from "./GeneralInfo.vue?vue&type=script&lang=ts"

import "./GeneralInfo.vue?vue&type=style&index=0&id=16355aac&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16355aac"]])

export default __exports__